import { useEffect, useState } from 'react'

/** Below Tailwind's `md` breakpoint: where the sidebar becomes a drawer. */
const PHONE_QUERY = '(max-width: 767px)'

function matches(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(PHONE_QUERY)?.matches === true
}

/**
 * True on phone-width screens. For layouts that differ in structure, not just
 * in spacing (a card list instead of a table, the favourites strip): CSS alone
 * would render both, and every link and button would exist twice.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(matches)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const mql = window.matchMedia(PHONE_QUERY)
    if (!mql) return
    const onChange = () => setIsMobile(mql.matches)
    onChange()
    mql.addEventListener?.('change', onChange)
    return () => mql.removeEventListener?.('change', onChange)
  }, [])

  return isMobile
}
